import type { Announcement } from '@zennolab_platform/data-access-notification-service-api';

import type { IAnnouncementEntity } from '../../types/announcement';

export const toAnnouncementEntity = (a: Announcement): IAnnouncementEntity => ({
  id: a.id,
  type: a.type,
  status: a.status,
  important: a.important,
  pinned: a.pinned,
  businessVersion: a.businessVersion,
  localizations: a.localizations.map(l => ({
    language: l.language,
    title: l.title,
    text: l.text,
    isDefault: l.isDefault,
    ctaLabel: l.ctaLabel,
    ctaUrl: l.ctaUrl,
  })),
  audience: a.audience && {
    tariffs: a.audience.tariffs,
    languages: a.audience.languages,
    versionMin: a.audience.versionMin,
    versionMax: a.audience.versionMax,
  },
  publishAt: a.publishAt,
  endAt: a.endAt,
  publishedAt: a.publishedAt,
  updatedAt: a.updatedAt,
});
